import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import { couponConfig } from '../store/config/coupon';
import {
  SET_GAME_COUPON_POPUP_SHOW_STATUS,
  UPDATE_GAME_ENABLE_COUPON_LIST,
  UPDATE_GAME_DISABLE_COUPON_LIST,
  UPDATE_GAME_EXPIRE_COUPON_LIST,
  LOAD_GAME_COUPON_LIST,
  UPDATE_GAME_ACTIVE_COUPON_ID,
  SET_VIP_COUPON_SHOW_STATUS,
  SET_BIRTH_COUPON_SHOW_STATUS,
  LOAD_VIP_COUPON_INFO
} from '@store/web/webStoreCoupon';

export default {
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      letter: state => state.letter,
      isShowGameCouponEntry: state =>
        state.webStoreCoupon.isShowGameCouponEntry,
      isShowGameCouponPopup: state =>
        state.webStoreCoupon.isShowGameCouponPopup,
      isShowGameItemUseBtn: state => state.webStoreCoupon.isShowGameItemUseBtn,
      gameCouponEnableList: state => state.webStoreCoupon.gameCouponEnableList,
      gameCouponDisableList: state =>
        state.webStoreCoupon.gameCouponDisableList,
      gameCouponExpireList: state => state.webStoreCoupon.gameCouponExpireList,
      gameActiveCouponId: state => state.webStoreCoupon.gameActiveCouponId,
      isShowVipCouponPopup: state => state.webStoreCoupon.isShowVipCouponPopup,
      isShowBirthCouponPopup: state =>
        state.webStoreCoupon.isShowBirthCouponPopup,
      vipLevel: state => state.webStoreCoupon.vipLevel,
      vipNextLevelPoint: state => state.webStoreCoupon.vipNextLevelPoint,
      vipSumPoint: state => state.webStoreCoupon.vipSumPoint,
      vipCouponList: state => state.webStoreCoupon.vipCouponList,
      birthCouponList: state => state.webStoreCoupon.birthCouponList,
      lang: state => state.lang
    }),
    ...mapGetters(['activeGameCouponProductList']),
    submitCouponInfoName() {
      if (!this.paytypeActiveCouponId) {
        return '';
      }

      if (this.activePaytypeCouponFullReductType) {
        return this.activePaytypeCouponReductionName;
      }

      return this.activePaytypeCouponDiscountName;
    },
    hasGameCoupon() {
      if (
        this.gameId &&
        couponConfig[+this.gameId] &&
        couponConfig[+this.gameId].isCoupon
      ) {
        if (+this.gameId === 274) {
          return this.lang === 'th-TH';
        }
        return true;
      }
      return false;
    },
    hasVip() {
      if (
        this.gameId &&
        couponConfig[+this.gameId] &&
        couponConfig[+this.gameId].isVipScore
      ) {
        if (+this.gameId === 274) {
          return this.lang === 'th-TH';
        }
        if (+this.gameId === 251) {
          return new Date() > new Date('2023/01/01 00:00:00');
        }
        return true;
      }
      return false;
    }
  },
  methods: {
    ...mapMutations({
      setGameCouponPopupShowStatus: SET_GAME_COUPON_POPUP_SHOW_STATUS,
      updateGameEnableCouponList: UPDATE_GAME_ENABLE_COUPON_LIST,
      updateGameDisableCouponList: UPDATE_GAME_DISABLE_COUPON_LIST,
      updateGameExpireCouponList: UPDATE_GAME_EXPIRE_COUPON_LIST,
      updateGameActiveCouponId: UPDATE_GAME_ACTIVE_COUPON_ID,
      setVipCouponShowStatus: SET_VIP_COUPON_SHOW_STATUS,
      setBirthCouponShowStatus: SET_BIRTH_COUPON_SHOW_STATUS
    }),
    ...mapActions({
      loadGameCouponList: LOAD_GAME_COUPON_LIST,
      loadVipCouponInfo: LOAD_VIP_COUPON_INFO
    }),
    hideGameCouponPopup() {
      this.setGameCouponPopupShowStatus(false);
    },
    showGameCouponPopup() {
      this.setGameCouponPopupShowStatus(true);
    },
    hideVipCouponPopup() {
      this.setVipCouponShowStatus(false);
    },
    hideBirthCouponPopup() {
      this.setBirthCouponShowStatus(false);
    },
    resetGameActiveCoupon() {
      this.updateGameActiveCouponId('');
    },
    checkInGameActiveCoupon(productId, cpProductId) {
      let length = this.activeGameCouponProductList.length;
      for (let i = 0; i < length; i++) {
        if (
          productId == this.activeGameCouponProductList[i].PRODUCT_ID &&
          cpProductId == this.activeGameCouponProductList[i].CP_PRODUCT_ID
        ) {
          return true;
        }
      }
      return false;
    },
    showVipCouponPopup() {
      this.setVipCouponShowStatus(true);
    },
    goVipPage() {
      this.$router.push({
        name: 'vipScore'
      });
    },
    refreshGameCoupon() {
      this.loadGameCouponList();
      this.showGameCouponPopup();
    }
  }
};
